import { DebitBudgetDialogInner } from "./DebitBudgetDialogInner";

import { ClientType } from "@/types/client/ClientType";

interface DebitBudgetDialogProps {
  clientId: string;
  open: boolean;
  onOpenChange: (open: boolean) => void;
  onSuccess: () => void;
  onCancel: () => void;
  client?: ClientType;
}

export const DebitBudgetDialog = ({
  open,
  onOpenChange,
  onSuccess,
  onCancel,
  ...props
}: DebitBudgetDialogProps) => {
  const handleOpenChange = (newOpen: boolean) => {
    onOpenChange(newOpen);
    if (!newOpen) {
      onCancel();
    }
  };

  const handleSuccess = () => {
    onSuccess();
  };

  return (
    <DebitBudgetDialogInner
      {...props}
      open={open}
      onOpenChange={handleOpenChange}
      onSuccess={handleSuccess}
    />
  );
};
